"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiError = void 0;
const JavaScriptObfuscatorFacade_1 = require("./src/JavaScriptObfuscatorFacade");
Object.defineProperty(exports, "ApiError", { enumerable: true, get: function () { return JavaScriptObfuscatorFacade_1.ApiError; } });
module.exports = JavaScriptObfuscatorFacade_1.JavaScriptObfuscator;
